import type { ToolMeta } from './registry';

export const getBudgetBreakdownMeta = {
  description:
    "Returns the couple's budget split by category with a share and a cash estimate for each. The tool for any 'what should I spend on X?' question.",
  examples: [
    'What should I spend on the venue?',
    'How much of my budget should go on photography?',
    'Break my budget down for me',
  ],
  value: 'what a wedding like theirs actually costs, category by category',
  grounding: 'budget',
} as const satisfies ToolMeta;
